import { PrimaryButton } from "@fluentui/react";

export const __OBJECT_STRUCTURE_GetList = (pageSize = 10, data = null) => {
    return { fireUpdate: true, data: data, pageNumber: 1, pageSize: pageSize, filters: [] }
}

export const _global_appTheme = {
    defaultFontStyle: { fontFamily: 'segoeui', fontWeight: 'regular' },
    fonts: {
        large: {
            fontFamily: 'segoeui'
        },
        medium: {
            fontFamily: 'segoeui'
        },
        mediumPlus: {
            fontFamily: 'segoeui'
        },
        mega: {
            fontFamily: 'segoeui'
        },
        small: {
            fontFamily: 'segoeui'
        },
        smallPlus: {
            fontFamily: 'segoeui'
        },
        superLarge: {
            fontFamily: 'segoeui'
        },
        tiny: {
            fontFamily: 'segoeui'
        },
        xLarge: {
            fontFamily: 'segoeui'
        },
        xSmall: {
            fontFamily: 'segoeui'
        },
        xxLarge: {
            fontFamily: 'segoeui'
        }
    }
};

export const primaryButtonStyles = {
    root: {
      backgroundColor: '#0078d4',
      borderColor: '#0078d4',
      color: '#ffffff',
    },
    rootHovered: {
      backgroundColor: '#106ebe',
      borderColor: '#106ebe',
      color: '#ffffff',
    },
    rootPressed: {
      backgroundColor: '#005a9e',
      borderColor: '#005a9e',
      color: '#ffffff',
    },
    rootFocused: {
      borderColor: '#0078d4',
      color: '#ffffff',
    },
    rootDisabled: {
      backgroundColor: '#eaeaea',
      borderColor: '#eaeaea',
      color: '#a6a6a6',
    },
  };

export const CustomCommandBarButton = ({ text, iconProps, onClick, style }) => (
    <PrimaryButton className='my-auto' text={text} iconProps={iconProps} onClick={onClick} style={style} />
);

export const _global_buttonStyles = { root: { marginRight: 8 } }